import ReactDOM from 'react-dom';
import ErrorBoundary from './ErrorBoundary';
import AppRouter from './AppRouter';
import ToolRouter from './ToolRouter';
import MainData from './stores/MainStore';
import './leadfeeder';

const render = (Component) => {
  ReactDOM.render(
    <ErrorBoundary>
      <Component/>
    </ErrorBoundary>,
    document.getElementById('app'),
  );
};

if (MainData.isApp) {
  render(AppRouter);

  require('../sass/entrypoint.scss');

  if (module.hot) {
    module.hot.accept('./AppRouter', () => { render(AppRouter); });
  }
} else {
  render(ToolRouter);
  if (module.hot) {
    module.hot.accept('./ToolRouter', () => { render(ToolRouter); });
  }
}

